module.exports = __webpack_public_path__ + "img/price_type_1.96e721a7.png";